import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { vendedorApi } from 'app/services/api/vendedorApi';
import React from 'react';

const SelectVendedor = ({ id, name, label, value, touched, error, onBlur, onChange, required, disabled }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      required={required}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.nome || option?.pessoa?.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await vendedorApi.pesquisar({
          size: 100,
          sort: 'pessoa.nome',
          page: next,
          q: query,
        });

        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
      disabled={disabled}
    />
  );
};

export default SelectVendedor;
